<template>
  <div class="sales-screen results">
    <section class="summary">
      <dl class="panels">
        <div>
          <dt>{{ $t('requests') }}</dt>
          <dd>
            <span class="value">{{ results.projectStats.requests }}</span>
          </dd>
        </div>
        <div>
          <dt>{{ $t('lab consulting applied') }}</dt>
          <dd>
            <span class="value">
              {{ results.projectStats.consultingApplied }}
              <small>{{ $t('of which effective') }}: {{ results.projectStats.consultingIncluded }}</small>
            </span>
          </dd>
        </div>
      </dl>
    </section>

    <section class="clients-nps">
      <header>
        <h2>{{ $t('Net promoter score') }}</h2>
      </header>

      <ul>
        <ClientNps v-for="client in clientsWithNps" :key="client.sqid" :client="client" />
      </ul>
    </section>
  </div>
</template>

<script setup lang="ts">
import ClientNps from '/@front:components/results/ClientNps.vue'
import GameLayout from '/@front:layouts/game.vue'
import type { ScenarioClientWithNPS } from '/@front:types/shared'

defineOptions({
  layout: [GameLayout],
})

defineProps<{
  results: Record<string, any>
  clientsWithNps: ScenarioClientWithNPS[]
}>()
</script>
